var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.104 23h4.44v-9h7.89v-3.72h-7.89V4.49h9.24V.8H3.104V23zm14.156 0h4.56l1.56-3.06c.48-1.02.93-2.01 1.41-2.97h.15c.54.96 1.08 1.98 1.62 2.97L28.42 23h4.74l-5.25-8.25 4.92-8.55h-4.56l-1.41 3c-.39.93-.84 1.89-1.23 2.82h-.12c-.51-.93-1.02-1.89-1.5-2.82l-1.68-3h-4.74l4.92 8.04L17.26 23zM.374 27.5H33.64V29H.374v-1.5z",
    fill: "#777E8C"
  })));
}

export default __webpack_public_path__ + "00cc612b084d7d2500925d57a51e685c.svg";
export { SvgFx as ReactComponent };